import React from 'react'
import styled from 'styled-components'

const StyledTitle = styled.h2`
  font-family: ${(props) => props.theme.font.family.secondary};
  font-size: ${(props) => props.theme.font.size['30']};
  line-height: 30px;
  margin-bottom: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.contrast};
  text-transform: uppercase;

  @media (max-width: 991px) {
    font-size: ${(props) => props.theme.font.size['24']};
    margin-bottom: 16px;
  }
`

interface TitleProps {
  children: any
  className?: string
}

function Title({ children, className = '' }: TitleProps) {
  return <StyledTitle className={className}>{children}</StyledTitle>
}

export default Title
